//============================
// 작업시간 변경 다이얼로그 (BS self-contained)
//
// 호출:
//   $j.Ui.BS.open({
//       target: '$j.F.Baljoo.ModalWorkDayTime',
//       data: {
//           ...orderInfo,
//           onApply: (data) => { ... }
//       }
//   });
//============================
import dayjs from "dayjs";
import Util from '../../../Common/Util';

export default class WorkDayTime {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
        this.instMobi = null;
    }
    /**
     * BS 가 this.id, this.parent, this.data 를 주입한 뒤 호출
     */
    init() {
        this.wt = this.data['work_time']; // 오리지널 work_time

        this.parent?.setTitle?.('도착시간');

        // skeleton 동기 렌더링 (꿀렁임 방지 + AJAX 라운드트립 제거)
        const wrapId = 'window-workdaytime';
        $('#' + this.id).html(`<div id="${wrapId}">${this.skeletonHtml()}</div>`);
        this.id = wrapId;

        this.initCalendar();
        this.draw();
        this.initHandler();
    }

    skeletonHtml() {
        let hourLi = '';
        for (let i = 0; i <= 23; i++) {
            hourLi += `<li class="flex item">${String(i).padStart(2, '0')}</li>`;
        }
        let minuteLi = '';
        for (let i = 0; i <= 5; i++) {
            minuteLi += `<li class="flex item">${String(i * 10).padStart(2, '0')}</li>`;
        }
        return `
<div class="flex_column modal_content" style="margin: 20px 0 0;">
    <div class="flex_column">
        <div class="division_2 flex_space_between ">
            <div class="flex title y_m_d"></div>
            <div class="flex">
                <div class="data flex_space_between" id="modal_worktime_H">
                    <div class="ymd_item">01</div>
                    <div class="bracket_bottom"><img src="/img/___bracket.png" alt="bracket"></div>
                    <ul class="hour_content">${hourLi}</ul>
                </div>
                <div class="flex title">시</div>
            </div>
            <div class="flex">
                <div class="data flex_space_between" id="modal_worktime_i">
                    <div class="ymd_item">00</div>
                    <div class="bracket_bottom"><img src="/img/___bracket.png" alt="bracket"></div>
                    <ul class="minute_content">${minuteLi}</ul>
                </div>
                <div class="flex title">분</div>
            </div>
        </div>
    </div>
</div>

<div style="margin-top: 30px;">
    <input class="calendar" type="hidden" />
</div>

<div class="modal_button flex apply-btn">
    <button id="workdaytime-apply-btn" class="button_gray">확인</button>
</div>`;
    }

    destroy() {
        if (this.instMobi) {
            try { this.instMobi.destroy?.(); } catch (e) {}
        }
        $('#' + this.id).off();
    }
    /**
     * 달력 초기화
     */
    initCalendar = function(){
        const self = this;
        $(`#${this.id} .calendar`).mobiscroll('destroy');

        let date = null;
        if( this.data['work_time'] ) {
            date = dayjs(this.data['work_time']).toDate();
        }

        this.instMobi = $(`#${this.id} .calendar`).mobiscroll().datepicker({
            controls: ['calendar'],
            display: 'inline',
            locale: mobiscroll.localeKo,
            defaultSelection: date,
            buttons: [],  // 설정 버튼 제거
            onCellClick: function (args, inst) {
                // https://mobiscroll.com/docs/jquery/datepicker/api#events
                /*
                [args]
                date: Date - The date of the clicked cell.
                domEvent: Event - The DOM event of the click.
                selected: boolean - Specifies if the day is currently selected or not (before it was clicked).
                target: HTMLElement - The DOM element of the clicked cell.

                [inst] 인스턴스
                 */
                // console.log(args); // 디버깅용

                if (args.date) {

                    // 다른 월의 날짜인 경우
                    if (args.outer) {
                        // console.log('다른 월의 날짜 선택됨:', args.date);
                        inst.navigate(args.date); // 월 이동 강제 처리
                        setTimeout(() => {
                            inst.setVal(args.date, true); // 날짜 선택 강제 적용
                            self.updateWorkDay(args.date); // 작업일 업데이트
                        }, 1); // 모바일 환경에서 지연 처리 (10ms)
                    } else {
                        // 현재 월의 날짜인 경우
                        inst.setVal(args.date, true); // 선택 강제 적용
                        self.updateWorkDay(args.date); // 작업일 업데이트
                    }
                }
            },
        }).mobiscroll('getInst');

        // 머리의 '오늘' — 칸 클릭과 같게 작업일을 반영한다 (내장 버튼은 onCellClick 을 안 태운다).
        // 감싼 요소에 건다: #{id} 는 initHandler 가 .off() 로 핸들러를 통째로 걷는다
        $j.Common.Mobiscroll.onToday($(`#${this.id} .calendar`).parent(), (d) => {
            self.setCalendarActive(true);
            self.updateWorkDay(d);
        });

        // 초기 상태에서 비활성화 설정
        self.setCalendarActive(false);

        // 캘린더 전체 클릭 시 활성화
        $(`#${this.id} .calendar`).on('click', function () {
            self.setCalendarActive(true);
        });
    }
    /**
     * 달력을 활성,비활성화 시킨다.
     * @param flag true(활성화), false(비활성화)
     */
    setCalendarActive = function(flag=true){
        const $el = $(`#${this.id} .calendar`);
        if( flag ){
            if ($el.hasClass('mobi-disabled')) {
                $el.removeClass('mobi-disabled'); // 비활성화 해제
            }
        }else{
            $el.addClass('mobi-disabled');
        }
    }
    /**
     * 이벤트 핸들러등록
     * off -> on 하는 이유는 윈도우여러번 닫았다 띄웠다 하면 핸들러가 중첩될수있기때문에 기존핸들러를 제거하기위함이다.
     */
    initHandler = function() {
        const self = this;
        // 아무데나 클릭하면 열려있던 팝업 닫히게
        $('#'+this.id).off().on('click',function(){
            self.closePopup();
        });

        // 년월일 클릭시
        $(`#${this.id} .y_m_d`).on('click',function(){
            self.setCalendarActive(true);
        });

        // 시분을 클릭했을때
        $('#'+this.id).on('click', '.data', function(e) {
            e.stopPropagation();//이벤트 전파막기
            self.closePopup();//열려진 모든 팝업을 닫는다.
            // console.log( $(this).attr('id'));
            if( $(this).attr('id')==self.where ) {// 같은곳을 클릭했다면
                self.where='';
                return;
            }
            self.where = $(this).attr('id');// 어디를 클릭했는지 저장해둔다.
            $(this).addClass('on');
            const v = $(this).find('div:first-child').html();
            let i=0;
            let idx=0;
            let $sel = null;
            $(this).find('li').each(function(){
                if( $(this).html()==v) { // 선택된 <li>
                    $(this).addClass('on');
                    idx=v;
                    $sel=$(this);
                }
                else $(this).removeClass('on');
                i++;
            });
            // console.log(idx);
            // 선택된걸 제일위에 표시되게
            if( idx>3 ) {
                $(this).find('ul').scrollTop(0);
                let h = $sel.offset().top - $(this).offset().top;
                // console.log('선택된아이템의 포지션',$sel.offset().top);
                // console.log('시작 포지션',$(this).offset().top);
                // console.log('계산값',h);
                // $(this).animate({scrollTop: h}, 'fast');
                $(this).find('ul').scrollTop(h-50);
            }
        });
        // 열려진 리스트중에 하나를 선택했을때
        $('#'+this.id).on('click', '.item', function(e) {
            e.stopPropagation();
            $(this).parent().parent().find('div:first-child').html( $(this).html() );
            self.closePopup();
            self.updateWorkTime();
        });
        // 확인버튼 클릭시
        $('#'+this.id+' .apply-btn').off().on('click',function(){
            self.apply();
        });
    }
    draw = function(){
        // 년월일 초기화
        let dj = dayjs(this.data['work_time']);
        $(`#${this.id} .y_m_d`).html(dj.format('YYYY-MM-DD') );

        // 시분 초기화
        const hi = [dj.format('HH'),dj.format('mm')];
        let i=0;
        $('#'+this.id).find('.ymd_item').each(function(){
            $(this).html(hi[i]);
            i++;
        });
    }
    /**
     * 날짜 선택 시 작업일시 업데이트
     * @param date 선택된 날짜
     */
    updateWorkDay = function (date) {
        const self = this;
        const work_day = dayjs(date).format('YYYY-MM-DD');
        const dj = dayjs(this.data['work_time']);
        this.data['work_time']=work_day+' '+dj.format('HH:mm:00');
        if( this.wt!=this.data['work_time'] ) {
            $('#workdaytime-apply-btn').removeClass('button_gray').addClass('button_yellow');
        }
    };
    /**
     * 시분 선택시 작업일시 업데이트
     */
    updateWorkTime = function () {
        let arr = [];
        $('#'+this.id).find('.ymd_item').each(function(){
            arr.push($(this).html());
        });
        const [H,i] = arr;//prefer-destructuring
        let time = ` ${H}:${i}:00`;
        const dj = dayjs(this.data['work_time']);
        this.data['work_time']= dj.format('YYYY-MM-DD')+' '+time;

        if( this.wt!=this.data['work_time'] ) {
            $('#workdaytime-apply-btn').removeClass('button_gray').addClass('button_yellow');
        }
    }
    /**
     * 현장도착시간 변경 완료시
     */
    apply = function() {
        if( this.wt==this.data['work_time'] ) {// 변경사항이 없다면 스킵
            Util.swalert('변경사항이 없습니다.');
            return;
        }
        const work_time = this.data['work_time'];
        let dj = dayjs(work_time);
        if( !dj.isValid() ){
            Util.swalert('날짜/시간을 정확하게 선택해주세요.');
            return;
        }
        this.data['work_time']=work_time;
        this.data['work_start_h']=dj.format('HH');
        this.data['work_start_m']=dj.format('mm');
        this.data['work_day']=dj.format('YYYY-MM-DD');

        const cb = this.data?.onApply;
        this.parent.close();
        if (typeof cb === 'function') cb(this.data);
    }
    /**
     * 열려져있는 팝업을 닫는다.
     */
    closePopup = function(){
        $('#'+this.id+' .data').removeClass('on');
    }
}
